<div class="mb-2 text-right">
  <!-- <button
    *ngIf="!showForm"
    id="saveBtn"
    i18n="@@TMRunButton"
    type="button"
    (click)="addRootCause()"
    [style.background-color]="backgroundColorButton"
    class="btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
    [style.background-color]="backgroundColorButton"
    style="padding: 0.3rem 1.6rem"
  >
    Root Cause <em style="margin: 0 0 0 0.5rem" class="fas fa-plus-circle"></em>
  </button> -->

  		  <app-common-button
        *ngIf="!showForm"
          label="Root Cause"
          title="Root Cause "
          icon="fas fa-plus-circle"
          [buttonId]="1111"
			width="130px"
          [critical]="false"
          (clicked)="addRootCause()"
           style="margin-left: 6px;margin-right:6px;"
          >
          </app-common-button>
</div>

<ag-grid-angular
  *ngIf="!showForm"
  class="ag-theme-balham"
  style="width: 100%; height: 300px"
  [rowData]="rootCauses"
  [defaultColDef]="defaultColDef"
  [columnDefs]="columnDefs"
  [gridOptions]="gridOptions"
  [pagination]="true"
  [paginationPageSize]="5"
  [enableBrowserTooltips]="true"
  (gridReady)="onGridReady($event)"
  [components]="components"
>
</ag-grid-angular>

<div *ngIf="showForm">
  <form [formGroup]="rootCauseForm" class="deviation-form">
    <!-- Row 1 -->
    <div class="form-row">
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Name of Root Cause</mat-label>
        <input
          matInput
          placeholder="Enter Rootcause Name "
          formControlName="rootCauseName"
           [errorStateMatcher]="errorStateMatcher"
        />
        <mat-error
          *ngIf="rootCauseForm.get('rootCauseName')?.hasError('required')"
        >
          Name of Root Cause is required
        </mat-error>
        <!-- <mat-hint *ngIf="!rootCauseForm.get('rootCauseName')?.invalid">Max 200 chars</mat-hint> -->
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Cause Type</mat-label>
        <mat-select formControlName="causeType"
         [errorStateMatcher]="errorStateMatcher">
          <mat-option *ngFor="let cT of causeType" [value]="cT.lookupvalue">
            {{ cT.lookupvalue }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="rootCauseForm.get('causeType')?.hasError('required')">
          Cause Type is required
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Category</mat-label>
        <mat-select formControlName="category"
         [errorStateMatcher]="errorStateMatcher">
          <mat-option *ngFor="let cT of Category" [value]="cT.lookupvalue">
            {{ cT.lookupvalue }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="rootCauseForm.get('category')?.hasError('required')">
          Category is required
        </mat-error>
      </mat-form-field>
    </div>

    <!-- Row 2 -->
    <div class="form-row two-column-row">
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Sub Category</mat-label>
        <mat-select formControlName="subCategory"
         [errorStateMatcher]="errorStateMatcher">
          <mat-option *ngFor="let cT of SubCategory" [value]="cT.lookupvalue">
            {{ cT.lookupvalue }}
          </mat-option>
        </mat-select>
        <mat-error
          *ngIf="rootCauseForm.get('subCategory')?.hasError('required')"
        >
          Sub Category is required
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Root Cause Analysis Type</mat-label>
        <mat-select formControlName="rootCauseAnalysisType"
         [errorStateMatcher]="errorStateMatcher">
          <mat-option
            *ngFor="let cT of rootCauseAnalysisType"
            [value]="cT.lookupvalue"
          >
            {{ cT.lookupvalue }}
          </mat-option>
        </mat-select>
        <mat-error
          *ngIf="
            rootCauseForm.get('rootCauseAnalysisType')?.hasError('required')
          "
        >
          Root Cause Analysis Type is required
        </mat-error>
      </mat-form-field>
    </div>
    <!-- Row 3 -->
    <div class="form-row two-column-row">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Description</mat-label>
        <textarea
          matInput
          formControlName="rootCauseDescription"
          rows="4"
          placeholder="Describe the deviation"
           [errorStateMatcher]="errorStateMatcher"
        ></textarea>
        <mat-error
          *ngIf="
            rootCauseForm.get('rootCauseDescription')?.hasError('required')
          "
        >
          Description is required
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Root Cause Analysis</mat-label>
        <textarea
          matInput
          formControlName="rootCauseAnalysis"
          rows="4"
          placeholder="Describe the deviation"
           [errorStateMatcher]="errorStateMatcher"
        ></textarea>
        <mat-error
          *ngIf="rootCauseForm.get('rootCauseAnalysis')?.hasError('required')"
        >
          Root Cause Analysis is required
        </mat-error>
      </mat-form-field>
    </div>

    <div class="step-footer mt-2">
      <div class="footer-left">
      <!-- <button
        i18n="@@TMRunButton"
        type="button"
        [style.border-color]="backgroundColorButton"
        class="cancelButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
        (click)="cancelForm()"
        style="padding: 0.3rem 1.6rem"
        [style.border-color]="backgroundColorButton"
      >
        Cancel
      </button> -->
       <app-common-button
          label="Cancel"
          title="Cancel "  
          [buttonId]="1111"
          variant="cancel"
          width="110px"
          [critical]="false"
          (clicked)="cancelForm()"
           style="margin-left: 6px;margin-right:6px;"
          >
          </app-common-button>
      </div>
      
      <div class="footer-right">
      <!-- <button
        id="saveBtn"
        i18n="@@TMRunButton"
        type="button"
        [style.background-color]="backgroundColorButton"
        class="btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
        [style.background-color]="backgroundColorButton"
        (click)="saveRootCause()"
        style="padding: 0.3rem 1.6rem"
      >
        {{ isEditMode ? 'UPDATE' : 'ADD' }}
      </button> -->

      		  <app-common-button
          label="{{ isEditMode ? 'Update' : 'Add' }}"
          title="{{ isEditMode ? 'Update' : 'Add' }}"
          [buttonId]="1111"
			    width="110px"
          [critical]="false"
          (clicked)="saveRootCause()"
           style="margin-left: 6px;margin-right:6px;"
          >
          </app-common-button>
      </div>
    </div>
  </form>
</div>
